





































import { Vue, Prop, Component } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";

@Component
export default class InviteUsersTableItem extends Vue {
  @Prop() user!: IUser;
  @Prop() index: any;
  data() {
    return {};
  }
  get screenWidth() {
    return window.innerWidth;
  }
}
